import { OrganizationMarket } from '../../../../../../../types/organizationMarket'

export const getPlanPriceSuffixTKey = (market: OrganizationMarket): string => {
  const priceSuffixByMarket: Record<string, string> = {
    default: 'organization_subscription.plans.price_suffix',
    nl: 'organization_subscription.plans.nl.price_suffix',
    de: 'organization_subscription.plans.de.price_suffix',
    fr: 'organization_subscription.plans.fr.price_suffix',
  }

  const marketMapper = market === '' ? 'default' : market

  return priceSuffixByMarket[marketMapper] || priceSuffixByMarket.default
}
